import DefaultRulesCell from './DefaultRulesCell'
import messageResource from '../../../../messageResource'
import SickDaysRulesMixin from './SickDaysRulesMixin'

class SickDaysDefaultRulesCell extends DefaultRulesCell {
    constructor() {
        super()
        this.defaultMessage = messageResource.getMessage("sick_days_rules_editor.default_sick_days_rules");
        this.mixin = new SickDaysRulesMixin();
    }
}

export default SickDaysDefaultRulesCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/SickDaysDefaultRulesCell.js